// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"b02745ed","317":"d51c6350","546":"56f974b4","592":"4eaf7482","662":"a26106d5","976":"2d5117b4"}[chunkId] + ".chunk.js";
};